import React from 'react';
import Webcam from 'react-webcam';
import { connect } from 'react-redux';
import * as types from 'constants/actionTypes';
import LOOKUP from 'constants/lookup';
import Button from './Button';
import DialogInput from '../advanced/DialogInput';
import DialogHeader from './DialogHeader';

class WebcamCapture extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            captureDialogOpen: false,
            visualizeDialogOpen: false
        };

        if (props.value) //if store has value relative to this component, initialize the state value
            this.state = { ...this.state, value: props.value, error: "" };
        else //in case the store does not have any value for this component, just clear it
            this.state = { ...this.state, value: "", error: "" };
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value !== this.state.value) {
            this.setState({ value: newProps.value });
        }

        if (newProps.error && newProps.error !== this.state.error)
            this.setState({ error: newProps.error });
    }

    setRef = (webcam) => {
        this.webcam = webcam;
    }

    openVisualizeDialog = () => {
        this.setState({ visualizeDialogOpen: true });
    }

    closeVisualizeDialog = () => {
        this.setState({ visualizeDialogOpen: false });
    }

    openCaptureDialog = () => {
        this.setState({ captureDialogOpen: true });
    }

    closeCaptureDialog = () => {
        this.setState({ captureDialogOpen: false });
    }

    capture = () => {
        const imageSrc = this.webcam.getScreenshot();
        this.props.dispatch({ type: types.FORM_INPUT, value: imageSrc, name: this.props.name });
        this.setState({ captureDialogOpen: false });
    };

    render() {
        const img = this.props.value;
        const p = this.props;
        const e = this.state && this.state.error;
        const patientId = this.props.patientId;

        return (
            <div name={p.name}>
                <div className="field">
                    <div className="imgContainer">
                        <div className="imgPreview"><img src={img} /></div>
                    </div>
                    <div className="imgButtons">
                        <Button
                            name="saveButton"
                            className="btn-space btnNewBrandPOS"
                            label={LOOKUP.components.webcamCapture.capture}
                            primary={true}
                            onTouchTap={() => this.openCaptureDialog()} />
                        {
                            img && this.props.enableDownload ? (<Button
                                name="saveButton"
                                className="btn-space"
                                label={"Download"}
                                href={img}
                                target="_blank"
                                // onTouchTap={() => this.props.download()}
                                download={patientId ? `${patientId}.png` : "patient.png"}
                                primary={true} />)
                                : null
                        }
                    </div>

                </div>
                <DialogInput
                    title={<DialogHeader text={LOOKUP.components.webcamCapture.dialogCaptureTitle} />}
                    modal={true}
                    open={this.state.captureDialogOpen}
                    autoScrollBodyContent={true}>
                    <div className="row">
                        <div className="col-lg-12">
                            <Webcam
                                ref={this.setRef}
                                audio={false}
                                height={480}
                                screenshotFormat="image/png"
                                style={{ margin: 'auto', display: 'block' }}
                                width={480} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <Button
                                name="saveButton"
                                className="pull-right btnNewBrandPOS"
                                label={LOOKUP.components.webcamCapture.capture}
                                primary={true}
                                onTouchTap={() => this.capture()} />
                            <Button
                                type="CancelButton"
                                name="buttonCancel"
                                className="pull-right btn-space btnCancelOperation"
                                label={LOOKUP.common.cancel.text}
                                onTouchTap={() => this.closeCaptureDialog()} />
                        </div>
                    </div>
                </DialogInput>
                <DialogInput
                    title={LOOKUP.components.webcamCapture.dialogVisualizeTitle}
                    modal={true}
                    open={this.state.visualizeDialogOpen}
                    autoScrollBodyContent={true}>
                    <div className="row">
                        <div className="col-lg-12">
                            <img src={this.props.value} style={{ display: 'block', margin: 'auto' }} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <Button
                                type="CancelButton"
                                name="buttonCancel"
                                className="pull-right btn-space"
                                label={LOOKUP.common.close.text}
                                onTouchTap={() => this.closeVisualizeDialog()} />
                        </div>
                    </div>
                </DialogInput>
                {(e && img === undefined) ? <span className="validationMessage">{p.error}</span> : ''}
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        value: state.form[props.name],
        error: state.form && state.form.error && state.form.error[props.name]
    };
};

export default connect(mapStateToProps)(WebcamCapture);